// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wcc-tag{display:inline-block;padding:0px 4px;background-color:#464646;color:#fff;border:1px solid transparent;border-radius:3px;font-size:11px;cursor:pointer}.wcc-tag--disabled{background-color:transparent !important;color:#868686 !important;border:1px dotted #868686}", ""]);
// Exports
module.exports = exports;
